import { OpenpanelService } from '../services/openpanel.service';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import {BookingService,HomeService, DataService, ItineraryServiceService, CarrierLogoService, SearchUrlService, SearchDescriptor } from '../services/index'
import { formatDate, Location  } from '@angular/common';
import * as $ from 'jquery';
import { PassDestinationValueService } from '../services/pass-destination-value.service';
import { PassDepatureValueService } from '../services/pass-depature-value.service';
import { ScrolltopService } from '../services/scrolltop.service';
import { Base64 } from 'js-base64';
import flightDestinations from '../../assets/data/destinations.json';
import * as moment from 'moment';
import mixpanel from 'mixpanel-browser';
import { FaroService } from '../services/faro.service';
import { FlightSearchBarComponent } from '../shared/flight-search-bar/flight-search-bar.component';
import { setCondensed } from '../shared/condense-sticky';

/** One column of the departure-date strip above the results. */
interface DateStripDay {
  key: string;            // yyyy-MM-dd
  date: Date;
  selected: boolean;
  fare: { amount: number; currency: string } | null;
  lowest: boolean;        // cheapest of the fares known in the visible window
  afterReturn: boolean;   // round trips: later than the return date, so not selectable
}

const DATE_STRIP_DAYS = 7;
const DATE_STRIP_PAGE = 3;

/** Parse a `yyyy-MM-dd` string as a local date (no UTC day shift). */
function parseYmd(value: string | null | undefined): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
  return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null;
}

function startOfToday(): Date {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

@Component({
    selector: 'app-booking',
    templateUrl: './booking.component.html',
    styleUrls: ['./booking.component.css'],
    standalone: false
})
export class BookingComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild('focustarget') focusEl: ElementRef;
  @ViewChild('dateStripTrack') dateStripTrack: ElementRef<HTMLElement>;
  @ViewChild('resultsSearchBar') resultsSearchBar: FlightSearchBarComponent;
  @ViewChild('resultsSearchBar', { read: ElementRef }) private resultsSearchBarHost?: ElementRef<HTMLElement>;
  @ViewChild('resultsSearch') private resultsSearch?: ElementRef<HTMLElement>;
  @ViewChild('mobileSearchBar') private mobileSearchBar?: ElementRef<HTMLElement>;

  /** One-time heads-up after the departure is changed on a round trip: the return date did not move. */
  stripNotice: { departure: string; returning: string } | null = null;
  private stripNoticeShown = false;
  private stripNoticeTimer: any = null;

  /** Seven-day departure strip above the results; fares fill in as dates are searched. */
  dateStrip: DateStripDay[] = [];
  private dateStripAnchor: Date | null = null;
  private fareByDate: Record<string, { amount: number; currency: string }> = {};
  private fareCacheKey = '';

  showModifySearch = false;
  /** Desktop/tablet: the search bar is stuck to the top of the page and renders condensed. */
  isSearchStuck = false;
  fromPlaceholder="From";
  toCityCode="To";
  fromCityCode="From";
  toPlaceholder="To";
  passengerPlaceholder=" pasenger"
  fromMobilePlaceholder=''
  toMobilePlaceholder=''
  public pickupplaceholder: string = 'Boarding Point';
  public dropoffplaceholder: string = 'Dropoff Point';
  public keyword = 'name';
  checkiftoday:boolean;
  public pickplaceholder: string = 'Enter Pick Up';
  public destplaceholder: string = 'Enter Drop Off';
  public historyHeading: string = 'Recently selected';
  today=new Date();
  isOpen=false;
  bsValue;
  bsInlineValue;
  destinationLoading=false;
  beforeyesterday:Date =( d => new Date(d.setDate(d.getDate()-2)) )(new Date);
  yesterday:Date = ( d => new Date(d.setDate(d.getDate()-1)) )(new Date);
  tomorrow:Date = ( d => new Date(d.setDate(d.getDate()+1)) )(new Date);
  aftertomorrow:Date = ( d => new Date(d.setDate(d.getDate()+2)) )(new Date);
  //traveldate:any;
  data = [];formdata={};
  formdataTravel={};
  formdataReturn={};
  private sub: any;
  res: any = {};
  return_schedule:any;
  schedule: any ={};
  routename: any ={};
  pickup:any =[];
  dropoff:any =[];
  dummyDropoff:any =[];
  seatsSelected: any=[];
  fleet: any ={};
  seat_price: any ={};
  params:any;
  bookingdetails: any;
  results: any ;
  isResultsLoading=false;
  seatErrors=false;
  showSeats=false;
  changeI=false;
  pickUpInit: string;
  dropOffInit: string;
  returnPickUpInit: string;
  returnDropOffInit: string;
  travelDateInit: string;
  returnDateInit:string;
  isUnavailabe=false;
  dataLoading=false;
  isPickupClicked=false;
  isReturnTicket=false;
  isReturnTicketSelected=false;
  isShowingFilter=false;
  totalFare=0;
  returning=false;
  passengers:any;
  selectedIndex = -1;
  hide_from_ui:number;
  availableSeats=[];
  seats =[];
  seatData:any =[];
  seatMobile:any =[];
  seatDataNew:any =[];
  seatRes:any;
  busCheckSelected:any;
  types= [];
  sticky: boolean = false;
  elementPosition: any;
  busSelected:any;
  isBusSelected:boolean =false;
  busOperatorSelected:any;
  selectedBus:any;
  currentBusId:any;
  selectedBusStatus:boolean=false;
  isAcClicked=false;
  isEmptyReturn=false;
  isWater=false;
  finalTravelDate: string;
  finalReturnDateInit:string;

  noOfDaysToReturn: any;
  midTripFlight: any;
  layOver: any;
  dayAbbrList: any = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  monthAbbrList: any = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  todayDate = formatDate(new Date(),"yyyy-MM-dd","en-KE");
  getYesterdaydate:Date = ( d => new Date(d.setDate(d.getDate()-1)) )(new Date);
  thisYesterdayDate=new Date();
  thistodayDate= new Date()
  //flights var def
    allFlights:any[]=[];
    availableFlights:any=[];
    paymentOptions: any[] = [];
    isavailableFlights: boolean = false
    searchError: string | null = null;
    classType:string;
    airlinesData:any;
    loadingCheckFlights=false;
    isArrayData=false;
    totalpassenger:any;
    dataholderTo:any;
    dataholderFrom:any;
    // sort & filter state
    readonly defaultSortOption = 'price_asc';
    currentSortOption = this.defaultSortOption;
    quickSortPreset: 'cheapest' | 'nonstop' | 'prefer' | null = 'cheapest';
    selectedStops: string[] = [];
    selectedDepartureBuckets: string[] = [];
    selectedArrivalBuckets: string[] = [];
    selectedAirlines: string[] = [];
    checkedBagOnly = false;
    airlineFacets: { code: string; name: string; count: number; logo?: string }[] = [];
    /** Per-option result counts with every *other* filter group applied (so counts stay honest as you narrow down). */
    facetCounts: {
      stops: Record<string, number>;
      departure: Record<string, number>;
      arrival: Record<string, number>;
      airlines: Record<string, number>;
      checkedBag: number;
    } = { stops: {}, departure: {}, arrival: {}, airlines: {}, checkedBag: 0 };
    /** Headline figure under each quick-sort button (cheapest fare, fastest duration, non-stop count). */
    quickSortMetrics: { cheapest: string | null; nonstop: string | null; prefer: string | null } = { cheapest: null, nonstop: null, prefer: null };
    totalResultCount = 0;
    filteredResultCount = 0;

    // mobile sort & filter sheet state
    isMobileSortFilterOpen = false;
    mobileSortFilterTab: 'sort' | 'filters' = 'sort';
    hasPendingMobileChanges = false;
    mobileSelectedSortOption = this.defaultSortOption;
    mobileSelectedStops: string[] = [];
    mobileSelectedDepartureBuckets: string[] = [];
    mobileSelectedArrivalBuckets: string[] = [];
    mobileSelectedAirlines: string[] = [];
    mobileCheckedBagOnly = false;
    topAirlineCode: string | null = null;
    topAirlineName: string | null = null;
    expandedFlightIndices: Set<number> = new Set();
    //end flights data
  constructor(
    private openpanel: OpenpanelService,
    private router: Router,
    private service:BookingService,
    private dataService:DataService,
    private itenaryservice: ItineraryServiceService,
    private serviceDestination: PassDestinationValueService,
    private serviceDepature:PassDepatureValueService,
    private _location: Location,
    public carrierLogoService: CarrierLogoService,
    private route: ActivatedRoute,
    private searchUrl: SearchUrlService,
    private faroService: FaroService,
  ) {

    
 
    var d = formatDate(this.getYesterdaydate,"yyyy-MM-dd","en-KE");
    this.thisYesterdayDate = new Date(d)
    this.thistodayDate=new Date(this.todayDate)
    this.trackScrollBehavior();
   }

   public flightCities:{name:string, code:string}[] = flightDestinations;


    showFilter () {
      this.isShowingFilter=true;
    }

    hideFilter() {
      this.isShowingFilter=false;
    }

  ngOnInit() {
    document.addEventListener('scroll', this.onAnyScroll, { capture: true, passive: true });
    this.router.events.subscribe((evt) => {
             if (!(evt instanceof NavigationEnd)) {
                 return;
             }
             window.scrollTo(0, 0)
         });

    this.dataService.currentMessage.pipe(takeUntil(this.destroy$)).subscribe(message =>{
      // 1. In-memory search (just navigated from home / modify-search): fastest path.
      if (message) {
        this.initFromMessage(message);
        return;
      }

      // 2. Shareable URL: rebuild the search straight from the query params so a
      //    pasted/shared link runs the same search on a fresh device.
      const descriptor = this.searchUrl.parse(this.route.snapshot.queryParams);
      if (descriptor) {
        this.initFromUrl(descriptor);
        return;
      }

      // 3. Returning to a previous search on this device.
      const stored = localStorage.getItem('searchFlights');
      if (stored) {
        this.initFromMessage(stored);
        return;
      }

      // 4. Nothing to search — back home.
      this.router.navigate(['/']);
    });

    this.checkDates();

    if (localStorage.getItem('modifySearchOpen') === '1') {
      this.showModifySearch = true;
    }

  }

  /** Run a search from a Base64 payload (in-memory or localStorage). */
  private initFromMessage(message: string): void {
    const data = JSON.parse(Base64.decode(message));
    this.bookingdetails = data;
    // Skip the API call when returning from a mobile sub-page (city, date, passenger pickers).
    // The flag is set by the search widget (app-flight-search-bar) before navigating to those routes.
    // Returning from payments does NOT set this flag, so flights are always re-fetched.
    const isSubpageReturn = sessionStorage.getItem('inSubpageNav') === '1';
    sessionStorage.removeItem('inSubpageNav');
    this.onSearch(data, isSubpageReturn);
  }

  /**
   * Rebuild a full search from a shareable URL. The query params only carry IATA
   * codes, so we look the airports up in airports.json to restore the full
   * from_data / destination_data objects the rest of the page relies on.
   */
  private initFromUrl(descriptor: SearchDescriptor): void {
    forkJoin({
      from: this.itenaryservice.getAirportByIata(descriptor.fromIata),
      to: this.itenaryservice.getAirportByIata(descriptor.toIata),
    }).pipe(takeUntil(this.destroy$)).subscribe(({ from, to }) => {
      const from_data = from || { iata: descriptor.fromIata, city: descriptor.fromIata, name: descriptor.fromIata, country: '' };
      const destination_data = to || { iata: descriptor.toIata, city: descriptor.toIata, name: descriptor.toIata, country: '' };
      const returning = descriptor.tripType === 'return';

      const data = {
        depature_city: descriptor.fromIata,
        destination_city: descriptor.toIata,
        departure_on: descriptor.onward,
        arrival_on: returning ? (descriptor.return || descriptor.onward) : descriptor.onward,
        trip_type: descriptor.tripType,
        adult_count: descriptor.adults,
        child_count: descriptor.children,
        infant_count: descriptor.infants,
        travel_class: descriptor.travelClass,
        from_data,
        destination_data,
        returning,
      };

      this.bookingdetails = data;
      // Keep the on-device stash in sync (without re-emitting, which would re-trigger
      // the currentMessage subscriber) so mobile sub-page navigation keeps working.
      localStorage.setItem('searchFlights', Base64.encode(JSON.stringify(data)));
      this.onSearch(data);
    });
  }

  ngAfterViewInit(): void {
    // Hack: Scrolls to top of Page after page view initialized
    let top = document.getElementById('tophome');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
  }

  ngOnDestroy(): void {
    document.removeEventListener('scroll', this.onAnyScroll, { capture: true } as any);
    this.destroy$.next();
    this.destroy$.complete();
  }



  interChangeValues(pickup,dropoff){
    this.fromPlaceholder = pickup.name;
    this.toPlaceholder = dropoff.name;
  }
  checkDates=() =>{
    let traveldate = this.travelDateInit;
    if (!traveldate) {
      // Nothing to derive the date navigation from yet (search still loading).
      return false;
    }
    let today = formatDate(this.today,"yyyy-MM-dd","en-KE");
    var date = new Date(traveldate);
    this.beforeyesterday=new Date(date.setDate(date.getDate()-2));
    this.yesterday=new Date(date.setDate(date.getDate()+1));
    this.tomorrow =new Date(date.setDate(date.getDate()+2))
    this.aftertomorrow =new Date(date.setDate(date.getDate()+2));
      if(traveldate == today)
        return true;
      else
        return false;
  }
  /** Move the departure date: re-run the search through the same path the widget uses and keep the URL shareable. */
  changeDate = (selected: Date | string) => {
    if (!this.bookingdetails) { return; }
    const next = formatDate(selected, 'yyyy-MM-dd', 'en-KE');
    const details = { ...this.bookingdetails, departure_on: next };
    if (!details.returning) {
      details.arrival_on = next;
    } else if (!details.arrival_on || details.arrival_on < next) {
      // The strip never offers a departure after the return; this is a safety net only.
      details.arrival_on = next;
    }
    this.dataService.changeMessage(Base64.encode(JSON.stringify(details)));
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: this.searchUrl.buildQueryParams(details),
      replaceUrl: true
    });
  }

  // ---------------------------------------------------------------------------
  // Departure-date strip
  // ---------------------------------------------------------------------------

  private rebuildDateStrip(): void {
    const selected = parseYmd(this.travelDateInit);
    if (!selected) {
      this.dateStrip = [];
      return;
    }
    const today = startOfToday();
    const half = Math.floor(DATE_STRIP_DAYS / 2);
    let anchor = this.dateStripAnchor;
    const windowEnd = anchor ? this.addDays(anchor, DATE_STRIP_DAYS - 1) : null;
    if (!anchor || selected.getTime() < anchor.getTime() || selected.getTime() > windowEnd.getTime()) {
      anchor = this.addDays(selected, -half);
    }
    if (anchor.getTime() < today.getTime()) {
      anchor = today;
    }
    this.dateStripAnchor = anchor;

    const returnKey = this.bookingdetails?.returning ? (this.bookingdetails.arrival_on || '') : '';
    const days: DateStripDay[] = Array.from({ length: DATE_STRIP_DAYS }, (_, i) => {
      const date = this.addDays(anchor, i);
      const key = formatDate(date, 'yyyy-MM-dd', 'en-KE');
      return {
        key,
        date,
        selected: key === this.travelDateInit,
        fare: this.fareByDate[key] ?? null,
        lowest: false,
        afterReturn: !!returnKey && key > returnKey
      };
    });
    const known = days.filter(day => day.fare && !day.afterReturn);
    if (known.length > 1) {
      const min = Math.min(...known.map(day => day.fare.amount));
      known.forEach(day => (day.lowest = day.fare.amount === min));
    }
    this.dateStrip = days;
    this.centerActiveStripDay();
  }

  shiftDateStrip(direction: -1 | 1): void {
    if (!this.dateStripAnchor) { return; }
    this.dateStripAnchor = this.addDays(this.dateStripAnchor, direction * DATE_STRIP_PAGE);
    this.rebuildDateStrip();
  }

  get canShiftDateStripBack(): boolean {
    return !!this.dateStripAnchor && this.dateStripAnchor.getTime() > startOfToday().getTime();
  }

  selectStripDate(day: DateStripDay): void {
    if (day.selected || day.afterReturn || this.isResultsLoading) { return; }
    if (this.bookingdetails?.returning && this.bookingdetails.arrival_on && !this.stripNoticeShown) {
      this.stripNoticeShown = true;
      this.stripNotice = { departure: day.key, returning: this.bookingdetails.arrival_on };
      clearTimeout(this.stripNoticeTimer);
      this.stripNoticeTimer = setTimeout(() => (this.stripNotice = null), 10000);
    }
    this.changeDate(day.date);
  }

  dismissStripNotice(): void {
    clearTimeout(this.stripNoticeTimer);
    this.stripNotice = null;
  }

  /** "Change return": the calendar in the search bar on desktop, the modify-search sheet on phones. */
  changeReturnDate(): void {
    this.dismissStripNotice();
    if (typeof window !== 'undefined' && window.innerWidth >= 992 && this.resultsSearchBar) {
      this.resultsSearchBar.openReturnPicker();
      return;
    }
    this.openModifySearch();
  }

  trackStripDay(_: number, day: DateStripDay): string {
    return day.key;
  }

  /** Remember the cheapest displayed fare for a searched departure date (same route, travellers and cabin). */
  private recordLowestFare(dateKey: string): void {
    const fares = this.allFlights
      .map(flight => (flight?.promo_discount ? this.getPromoFinalAmount(flight) : Number(flight?.total_amount)))
      .filter(amount => Number.isFinite(amount) && amount > 0);
    if (fares.length) {
      this.fareByDate[dateKey] = { amount: Math.min(...fares), currency: this.allFlights[0]?.total_currency || 'KES' };
    } else {
      delete this.fareByDate[dateKey];
    }
    this.rebuildDateStrip();
  }

  /** Drop cached fares when anything other than the departure date changes. */
  private resetFareCacheIfNeeded(data: any): void {
    const key = [
      data?.depature_city, data?.destination_city, data?.trip_type, data?.returning ? data?.arrival_on : '',
      data?.adult_count, data?.child_count, data?.infant_count, data?.travel_class
    ].join('|');
    if (key !== this.fareCacheKey) {
      this.fareCacheKey = key;
      this.fareByDate = {};
      // A different search (route, return date, travellers): the heads-up may show once more.
      this.stripNoticeShown = !!this.stripNotice;
    }
  }

  /** Mobile: the strip scrolls horizontally; keep the selected day in view. */
  private centerActiveStripDay(): void {
    setTimeout(() => {
      const track = this.dateStripTrack?.nativeElement;
      const active = track?.querySelector<HTMLElement>('.date-strip__day--active');
      if (!track || !active || track.scrollWidth <= track.clientWidth) { return; }
      const activeLeft = active.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      track.scrollLeft = Math.max(0, activeLeft - (track.clientWidth - active.offsetWidth) / 2);
    }, 50);
  }

    onFlightCardSelect(result: any): void {
    if (this.loadingCheckFlights) {
      return;
    }

    this.getFlightDetails(result);
  }

  toggleFlightDetail(index: number, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (this.expandedFlightIndices.has(index)) {
      this.expandedFlightIndices.delete(index);
    } else {
      this.expandedFlightIndices.add(index);
    }
  }

  isFlightDetailExpanded(index: number): boolean {
    return this.expandedFlightIndices.has(index);
  }

  getFlightDetails(result){
      // Clear scroll timeout if user selects a flight
  if (typeof window !== 'undefined' && window['scrollTimeout']) {
    clearTimeout(window['scrollTimeout']);
  }
    mixpanel.track('Flight Selection', {
      'departure_on': this.bookingdetails.departure_on,
      'arrival_on': this.bookingdetails.arrival_on,
      'trip_type': this.bookingdetails.trip_type,
      'adult_count': this.bookingdetails.adult_count,
      'child_count': this.bookingdetails.child_count,
      'infant_count': this.bookingdetails.infant_count,
      'travel_class': this.bookingdetails.travel_class,
      'flight-id': result.result_id,
      'flight-airline': this.getFlightName(result),
      'flight-gds': result.gds,
      'flight-departure': this.getFlightDeparture(result),
      'flight-arrival': this.getFlightArrival(result),
      'flight-price': result.total_amount,
      'flight-iata': this.getFlightIata(result),
    });
    //check if selected flight is aerocrs
    let dataf=[]

    this.openpanel.track('flight_selected', {
      airline: this.getFlightIata(result),
      amount: result?.total_amount,
      arrival: this.getFlightArrival(result)
    });
    this.faroService.pushEvent('trip_selected', {
      flight_id: result.result_id,
      airline: this.getFlightName(result),
      gds: result.gds,
      fare: result.total_amount,
      departure: this.getFlightDeparture(result),
      arrival: this.getFlightArrival(result),
    });
    const selectedFlight = {
      ...result,
      payment_options: result?.payment_options || this.paymentOptions
    };

    let  final_data = {
      "flight_data":selectedFlight,
      "passengers":this.passengers,
   
    }
    
      const payJson = JSON.stringify(final_data);
      this.dataService.changePaymentMessage(Base64.encode(payJson));
      // Carry the payload in the URL so the payment page is reachable from any platform.
      this.router.navigate(['/payments', Base64.encodeURI(payJson)])


  }
//seg.segments[0].marketing_carrier.flight_number
  getFlightName(result:any){
    return result.slices[0].segments[0].marketing_carrier.name;
  }


  getFlightIata(result:any){
    return result.slices[0].segments[0].marketing_carrier.iata_code;
  }

  getFlightDeparture(result:any){
    return result.slices[0].segments[0].departing_at;
  }

  getFlightArrival(result:any){
    return result.slices[0].segments[0].arriving_at;
  }




  interChange=()=>{
    this.changeI=!this.changeI;
    if(this.changeI){
       const dropOff = this.data.find(city => city === this.dropOffInit);
       const pickUp = this.data.find(city => city === this.pickUpInit);
      let webformdata={
        'pickup' : dropOff,
        'dropoff' : pickUp,
        'pickupname' : dropOff,
        'dropoffname' :pickUp,
        'traveldate' :this.travelDateInit,
        'returndate' :this.returnDateInit,
        'returning' : this.returning
      }
      this.interChangeValues(dropOff,pickUp);
      // TO DO
      // this.onSearch(webformdata)
  
    }else{
       const dropOff = this.data.find(city => city === this.dropOffInit);
       const pickUp = this.data.find(city => city === this.pickUpInit);
      let webformdata={
        'pickup' : pickUp,
        'dropoff' : dropOff,
        'pickupname' : pickUp,
        'dropoffname' :dropOff,
        'traveldate' :this.travelDateInit,
        'returndate' :this.returnDateInit,
        'returning' : this.returning
      }
      this.interChangeValues(pickUp,dropOff);
      // TO DO
      // this.searchBuses(webformdata);
    }
  }


  backHome(){
    this.router.navigateByUrl('/');
  }

  openModifySearch() {
    this.showModifySearch = true;
    localStorage.setItem('modifySearchOpen', '1');
  }

  closeModifySearch() {
    this.showModifySearch = false;
    localStorage.removeItem('modifySearchOpen');
  }

  /**
   * Condense the sticky search bar once the page has scrolled past its resting
   * position. The layout scrolls the <body> element (not the window), and scroll
   * events do not bubble, so listen in the capture phase on the document.
   */
  private readonly onAnyScroll = (): void => {
    const y = Math.max(
      window.scrollY || 0,
      document.documentElement?.scrollTop || 0,
      document.body?.scrollTop || 0
    );
    const stuck = y > 24;
    if (stuck !== this.isSearchStuck) {
      // Condense synchronously, the child bar's is-condensed host class included,
      // so the height each bar loses is given back before the browser can
      // anchor-scroll (see setCondensed).
      const desktopBar = this.resultsSearch?.nativeElement;
      if (desktopBar) {
        setCondensed(desktopBar, 'results-search--stuck', stuck, [
          { el: this.resultsSearchBarHost?.nativeElement, className: 'is-condensed' },
        ]);
      }
      const mobileBar = this.mobileSearchBar?.nativeElement;
      if (mobileBar) {
        setCondensed(mobileBar, 'mobile-search-summary-bar--stuck', stuck);
      }
      this.isSearchStuck = stuck;
    }
  };

  addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  forMatThisData = (data) => {
    return formatDate(data,"dddd dS, M","en-KE");
  }

  //track user scroll behavior in mixpanel
  trackScrollBehavior() {
    console.log('trackScrollBehavior');
    const scrollContainer = document.querySelector('.scroll-container');
    if (!scrollContainer) return;
  
    let hasTrackedScroll = false;
    let scrollTimeout: any;
  
    scrollContainer.addEventListener('scroll', () => {
      const scrollTop = scrollContainer.scrollTop;
      const scrollHeight = scrollContainer.scrollHeight;
      const clientHeight = scrollContainer.clientHeight;
      const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
  
      // Track detailed scroll metrics
      mixpanel.track('Scroll Behavior', {
        'scroll_percentage': scrollPercentage,
        'scroll_position': scrollTop,
        'scroll_height': scrollHeight,
        'scroll_client_height': clientHeight
      });
  
      // If user scrolls beyond 70% of the results and hasn't selected a flight
      if (!hasTrackedScroll && scrollPercentage > 70) {
        hasTrackedScroll = true;
  
        scrollTimeout = setTimeout(() => {
          if (!this.loadingCheckFlights) {
            mixpanel.track('Scrolled Flights Without Selection', {
              'departure_on': this.bookingdetails.departure_on,
              'arrival_on': this.bookingdetails.arrival_on,
              'trip_type': this.bookingdetails.trip_type,
              'adult_count': this.bookingdetails.adult_count,
              'child_count': this.bookingdetails.child_count,
              'infant_count': this.bookingdetails.infant_count,
              'travel_class': this.bookingdetails.travel_class,
              'departure_city': this.bookingdetails.from_data.name,
              'destination_city': this.bookingdetails.destination_data.name
            });
          }
        }, 5000); // wait 5 seconds to assume indecision
      }
    });
  }
  


  onSearch(data, skipApiCall = false) {
    this.totalpassenger = (data.adult_count || 0) + (data.child_count || 0) + (data.infant_count || 0);
    this.passengers ={
      "adult":data.adult_count,
      "child":data.child_count,
      "infant":data.infant_count,
      "total_passengers": this.totalpassenger
    }

    let mdata ={
        "departure_on":data.departure_on,
        "arrival_on": data.arrival_on,
        "trip_type":data.trip_type,
        "adult_count":data.adult_count,
        "child_count":data.child_count,
        "infant_count":data.infant_count,
        "travel_class": data.travel_class
      
    }
    //add depature and destination cities
    mixpanel.track('Flight Search', {
      'departure_on': data.departure_on,
      'arrival_on': data.arrival_on,
      'trip_type': data.trip_type,
      'adult_count': data.adult_count,
      'child_count': data.child_count,
      'infant_count': data.infant_count,
      'travel_class': data.travel_class,
      'departure_city': this.bookingdetails.from_data.name,
      'destination_city': this.bookingdetails.destination_data.name
    });

// set UI values
    this.pickUpInit=this.bookingdetails.from_data.iata;
    this.dropOffInit=this.bookingdetails.destination_data.iata;
    this.travelDateInit=this.bookingdetails.departure_on;
    this.returnDateInit=this.bookingdetails.arrival_on;
    this.fromPlaceholder = this.bookingdetails.from_data.iata;
    this.toPlaceholder = this.bookingdetails.destination_data.iata;
    this.dataholderTo = this.bookingdetails.destination_data.name;
    this.dataholderFrom = this.bookingdetails.from_data.name;
    this.fromMobilePlaceholder = this.bookingdetails.from_data.city;
    this.toMobilePlaceholder=this.bookingdetails.destination_data.city
    this.classType = this.bookingdetails.travel_class;
    this.toCityCode = this.bookingdetails.destination_data.iata;
    this.fromCityCode = this.bookingdetails.from_data.iata;
    this.returning=this.bookingdetails.returning;
    this.resetFareCacheIfNeeded(data);
    this.rebuildDateStrip();
    this.serviceDepature.changeValue(this.pickUpInit);
    this.serviceDestination.changeValue(this.dropOffInit);
    this.bsValue=new Date(formatDate(this.bookingdetails.departure_on,"yyyy-MM-dd","en-KE"));

    if (skipApiCall) { return; }

    this.allFlights = []
    this.availableFlights = []
    this.isavailableFlights = false
    this.searchError = null;
    this.isResultsLoading=true;
    this.itenaryservice.getFlightSchedule(
          data.depature_city,
          data.destination_city,
          mdata).subscribe(
      (nextdata) => {
        const responseData = Array.isArray(nextdata) ? nextdata : nextdata?.data;
        this.paymentOptions = Array.isArray(nextdata?.payment_options) ? nextdata.payment_options : [];
        this.allFlights = this.dedupeIdenticalOffers(Array.isArray(responseData) ? responseData : []);
        this.totalResultCount = this.allFlights.length;
        this.rebuildAirlineFacets();
        this.applyFiltersAndSort();
        this.recordLowestFare(data.departure_on);
        if (this.availableFlights.length < 1) {
          this.isavailableFlights = false;
          this.isResultsLoading = false;
          // wait for 5 seconds
          setTimeout(() => {
            this.trackNoFlights();
          }, 5000);
          return;
        }
        this.isavailableFlights = true;
        this.isResultsLoading = false;

      },
      (error) => {
        this.isResultsLoading = false;
        if (error?.status === 401) {
          this.searchError = 'Your session has expired. Please search again to continue.';
        } else {
          this.searchError = 'Unable to load flights. Please try again.';
        }
      }
    )
  }
  
  trackNoFlights() {
    mixpanel.track('No Flights Found', {
      'departure_on': this.bookingdetails.departure_on,
      'arrival_on': this.bookingdetails.arrival_on,
      'trip_type': this.bookingdetails.trip_type,
      'adult_count': this.bookingdetails.adult_count,
      'child_count': this.bookingdetails.child_count,
      'infant_count': this.bookingdetails.infant_count,
      'travel_class': this.bookingdetails.travel_class,
      'departure_city': this.bookingdetails.from_data.name,
      'destination_city': this.bookingdetails.destination_data.name
    });
    // no_results_found: state-based, not route-based - <app-nobuses> renders
    // inline in the template, the URL never changes to /nobuses, so this
    // (mirroring the existing Mixpanel call above) is the only place this
    // can be detected.
    this.faroService.pushEvent('no_results_found', {
      departure_city: this.bookingdetails?.from_data?.name,
      destination_city: this.bookingdetails?.destination_data?.name,
      trip_type: this.bookingdetails?.trip_type,
    });
  }

  toggleShow(results: any) {
      this.seatsSelected=[];
      this.totalFare=0;
      this.dataLoading=false;
      this.hide_from_ui = 0;
      $("#mySidenav").width('0px');
      $(".fadeMe").hide();
    }




  

  trackByBooking(result: any, index: number) {
    return result.offer_id ?? result.result_id ?? result.id ?? index;
  }


  /** Quick sorts shown in the results toolbar. Each maps to a plain sort; filters are left untouched. */
  readonly quickSortOptions: { id: 'cheapest' | 'nonstop' | 'prefer'; label: string; sort: string }[] = [
    { id: 'cheapest', label: 'Cheapest', sort: 'price_asc' },
    { id: 'nonstop', label: 'Non-stop first', sort: 'nonstop_first' },
    { id: 'prefer', label: 'Fastest', sort: 'duration_asc' }
  ];

  readonly secondarySortOptions = [
    { value: 'price_asc', label: 'Price: Cheapest first' },
    { value: 'price_desc', label: 'Price: Costliest first' },
    { value: 'duration_asc', label: 'Duration: Shortest travel time' },
    { value: 'duration_desc', label: 'Duration: Longest travel time' },
    { value: 'nonstop_first', label: 'Stops: Non-stop first' },
    { value: 'dep_time_asc', label: 'Departure: Earliest first' },
    { value: 'dep_time_desc', label: 'Departure: Latest first' },
    { value: 'arr_time_asc', label: 'Arrival: Earliest first' },
    { value: 'arr_time_desc', label: 'Arrival: Latest first' }
  ];

  readonly stopFilterOptions = [
    { value: '0', label: 'Non-stop' },
    { value: '1', label: '1 stop' },
    { value: '2p', label: '2+ stops' }
  ];

  readonly timeBucketOptions = [
    { value: 'before6', label: 'Before 6AM' },
    { value: '6to12', label: '6AM – 12 Noon' },
    { value: '12to18', label: '12 Noon – 6PM' },
    { value: 'after18', label: 'After 6PM' }
  ];

  get hasActiveFilters() {
    return (
      this.selectedStops.length > 0 ||
      this.selectedDepartureBuckets.length > 0 ||
      this.selectedArrivalBuckets.length > 0 ||
      this.selectedAirlines.length > 0 ||
      this.checkedBagOnly
    );
  }

  get mobilePreviewCount(): number {
    const stopsSet = new Set(this.mobileSelectedStops);
    const depSet = new Set(this.mobileSelectedDepartureBuckets);
    const arrSet = new Set(this.mobileSelectedArrivalBuckets);
    const airlineSet = new Set(this.mobileSelectedAirlines);
    return this.filterFlightsWith(stopsSet, depSet, arrSet, airlineSet, this.mobileCheckedBagOnly).length;
  }

  private dedupeIdenticalOffers(flights: any[]): any[] {
    if (flights.length === 0) return flights;

    const seen = new Set<string>();
    const result: any[] = [];

    for (const flight of flights) {
      const key = this.buildDisplayKey(flight);
      if (!key) {
        result.push(flight);
        continue;
      }
      if (!seen.has(key)) {
        seen.add(key);
        result.push(flight);
      }
    }

    return result;
  }

  private buildDisplayKey(flight: any): string | null {
    if (!flight?.slices?.length) return null;

    const sliceKeys = flight.slices.map((slice: any) => {
      const seg = slice?.segments?.[0];
      const origin = slice?.origin?.iata_code ?? seg?.origin?.iata_code;
      const destination = slice?.destination?.iata_code ?? seg?.destination?.iata_code;
      const dep = seg?.departing_at ?? slice?.departing_at;
      const arr = seg?.arriving_at ?? slice?.arriving_at;
      const flightNum = seg?.marketing_carrier_flight_number ?? seg?.flight_number ?? '';
      const carrier = seg?.marketing_carrier?.iata_code ?? '';
      if (!origin || !destination || !dep || !arr) return null;
      return [origin, destination, dep, arr, carrier, flightNum].join('|');
    });

    if (sliceKeys.some((k: string | null) => k === null)) return null;

    const gds = flight.gds ?? '';
    const amount = flight.total_amount ?? '';
    const currency = flight.total_currency ?? '';
    const cabin = flight.cabin_class ?? flight.slices?.[0]?.fare_brand_name ?? '';
    const baggage = flight.slices?.[0]?.segments?.[0]?.passengers?.[0]?.baggages
      ?.map((b: any) => `${b.quantity}${b.type}`).join(',') ?? '';

    return [gds, ...sliceKeys, amount, currency, cabin, baggage].join('||');
  }

  private getFlightAmount(flight: any): number {
    const amount = flight?.total_amount;
    if (typeof amount === 'number') {
      return amount;
    }

    if (typeof amount === 'string') {
      const normalized = amount.replace(/,/g, '');
      const parsed = parseFloat(normalized);
      if (!isNaN(parsed)) {
        return parsed;
      }
    }

    return Number.MAX_SAFE_INTEGER;
  }

  private getDurationMinutes(flight: any): number {
    const duration = flight?.slices?.[0]?.duration || flight?.gds_response?.itineraries?.[0]?.duration;
    if (!duration || typeof duration !== 'string') {
      return Number.MAX_SAFE_INTEGER;
    }

    const regex = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/;
    const match = duration.match(regex);
    if (!match) {
      return Number.MAX_SAFE_INTEGER;
    }

    const hours = match[1] ? parseInt(match[1], 10) : 0;
    const minutes = match[2] ? parseInt(match[2], 10) : 0;
    const seconds = match[3] ? parseInt(match[3], 10) : 0;

    return hours * 60 + minutes + Math.ceil(seconds / 60);
  }

  private getDepartureTime(flight: any): string | null {
    const segment = this.getFirstSegment(flight);
    return segment?.departing_at || segment?.departure?.at || flight?.slices?.[0]?.departing_day || null;
  }

  private getArrivalTime(flight: any): string | null {
    const segment = this.getLastSegment(flight);
    return segment?.arriving_at || segment?.arrival?.at || flight?.slices?.[0]?.arriving_day || null;
  }

  private getFirstSegment(flight: any): any {
    if (!flight?.slices || flight.slices.length === 0) {
      return null;
    }
    return flight.slices[0]?.segments?.[0] || null;
  }

  private getLastSegment(flight: any): any {
    if (!flight?.slices || flight.slices.length === 0) {
      return null;
    }
    const lastSlice = flight.slices[flight.slices.length - 1];
    if (!lastSlice?.segments || lastSlice.segments.length === 0) {
      return null;
    }
    return lastSlice.segments[lastSlice.segments.length - 1];
  }

  // Human-readable stop count for a single slice (leg). Derived from the
  // number of segments, since the GDS slice-level `stops` field is unreliable
  // (it reflects technical stops, not connections).
  /** "1 x 15 KG" / "2 pieces"; null when the fare includes no such bag. */
  bagSummary(bag: any): string | null {
    const quantity = Number(bag?.quantity) || 0;
    if (quantity <= 0) {
      return null;
    }
    const weight = Number(bag?.weight) || 0;
    if (weight > 0) {
      return `${quantity} x ${weight} ${bag?.unit || 'KG'}`;
    }
    return quantity === 1 ? '1 piece' : `${quantity} pieces`;
  }

  /** Phones and tablets: tapping anywhere on the card starts the booking, as before. */
  onCardTap(result: any, event: Event): void {
    if (typeof window === 'undefined' || window.innerWidth >= 992) {
      return;
    }
    const target = event.target as HTMLElement | null;
    if (target?.closest('button, a, .fl-details')) {
      return;
    }
    this.onFlightCardSelect(result);
  }

  stopLabel(slice: any): string {
    const stopCount = Math.max(0, (slice?.segments?.length ?? 1) - 1);
    if (stopCount <= 0) {
      return 'Non-stop';
    }
    return stopCount === 1 ? '1 stop' : `${stopCount} stops`;
  }

  private getStopsKey(flight: any): string {
    const slices = flight?.slices ?? [];
    if (!slices.length) {
      return '0';
    }

    // Classify the trip by its worst (most stops) leg so round trips with a
    // connection on either the outbound or return leg are bucketed correctly.
    const maxStops = Math.max(
      ...slices.map((slice: any) => Math.max(0, (slice?.segments?.length ?? 1) - 1))
    );

    if (maxStops <= 0) {
      return '0';
    }
    if (maxStops === 1) {
      return '1';
    }
    return '2p';
  }

  private hasCheckedBag(flight: any): boolean {
    const cabins = flight?.available_cabins;
    if (Array.isArray(cabins)) {
      for (const cabin of cabins) {
        const quantity = cabin?.checked_bag?.quantity;
        if (typeof quantity === 'number' && quantity > 0) {
          return true;
        }
      }
    }

    const travelerPricings = flight?.gds_response?.travelerPricings;
    if (Array.isArray(travelerPricings)) {
      for (const traveler of travelerPricings) {
        const fareDetails = traveler?.fareDetailsBySegment;
        if (Array.isArray(fareDetails)) {
          for (const detail of fareDetails) {
            const bag = detail?.includedCheckedBags;
            if (bag && typeof bag.quantity === 'number' && bag.quantity > 0) {
              return true;
            }
          }
        }
      }
    }

    return false;
  }

  private stopsRank(flight: any): number {
    const key = this.getStopsKey(flight);
    return key === '0' ? 0 : key === '1' ? 1 : 2;
  }

  private formatMinutes(total: number): string {
    if (!Number.isFinite(total) || total >= Number.MAX_SAFE_INTEGER) {
      return '';
    }
    const hours = Math.floor(total / 60);
    const minutes = total % 60;
    return hours ? (minutes ? `${hours}h ${minutes}m` : `${hours}h`) : `${minutes}m`;
  }

  get activeFilterCount(): number {
    return (
      this.selectedStops.length +
      this.selectedDepartureBuckets.length +
      this.selectedArrivalBuckets.length +
      this.selectedAirlines.length +
      (this.checkedBagOnly ? 1 : 0)
    );
  }

  /** Clear the filters but keep the chosen sort. */
  clearFilterSelections(): void {
    this.selectedStops = [];
    this.selectedDepartureBuckets = [];
    this.selectedArrivalBuckets = [];
    this.selectedAirlines = [];
    this.checkedBagOnly = false;
    this.applyFiltersAndSort();
  }

  private rebuildFacetCounts(): void {
    const stopsSet = new Set(this.selectedStops);
    const depSet = new Set(this.selectedDepartureBuckets);
    const arrSet = new Set(this.selectedArrivalBuckets);
    const airlineSet = new Set(this.selectedAirlines);
    const none = new Set<string>();
    const tally = (flights: any[], keyOf: (flight: any) => string | null): Record<string, number> => {
      const counts: Record<string, number> = {};
      flights.forEach(flight => {
        const key = keyOf(flight);
        if (key) {
          counts[key] = (counts[key] || 0) + 1;
        }
      });
      return counts;
    };
    const bucketOf = (time: string | null): string | null => {
      if (!time) { return null; }
      const option = this.timeBucketOptions.find(o => this.isTimeInBucket(time, o.value));
      return option ? option.value : null;
    };

    this.facetCounts = {
      stops: tally(this.filterFlightsWith(none, depSet, arrSet, airlineSet, this.checkedBagOnly), f => this.getStopsKey(f)),
      departure: tally(this.filterFlightsWith(stopsSet, none, arrSet, airlineSet, this.checkedBagOnly), f => bucketOf(this.getDepartureTime(f))),
      arrival: tally(this.filterFlightsWith(stopsSet, depSet, none, airlineSet, this.checkedBagOnly), f => bucketOf(this.getArrivalTime(f))),
      airlines: tally(this.filterFlightsWith(stopsSet, depSet, arrSet, none, this.checkedBagOnly), f => this.getMarketingCarrierCode(f) || '??'),
      checkedBag: this.filterFlightsWith(stopsSet, depSet, arrSet, airlineSet, false).filter(f => this.hasCheckedBag(f)).length
    };
  }

  private rebuildQuickSortMetrics(flights: any[]): void {
    if (!flights.length) {
      this.quickSortMetrics = { cheapest: null, nonstop: null, prefer: null };
      return;
    }
    const amounts = flights.map(f => this.getFlightAmount(f)).filter(a => Number.isFinite(a) && a > 0);
    const currency = flights[0]?.total_currency || 'KES';
    const fastest = Math.min(...flights.map(f => this.getDurationMinutes(f)));
    const nonstop = flights.filter(f => this.getStopsKey(f) === '0').length;
    this.quickSortMetrics = {
      cheapest: amounts.length ? `${currency} ${Math.round(Math.min(...amounts)).toLocaleString('en-KE')}` : null,
      nonstop: `${nonstop} non-stop`,
      prefer: this.formatMinutes(fastest) || null
    };
  }

  private sortFlights(flights: any[], sortOption: string): any[] {
    if (!Array.isArray(flights) || flights.length === 0) {
      return flights || [];
    }

    const comparatorMap: { [key: string]: (a: any, b: any) => number } = {
      price_asc: (a, b) => this.getFlightAmount(a) - this.getFlightAmount(b),
      price_desc: (a, b) => this.getFlightAmount(b) - this.getFlightAmount(a),
      nonstop_first: (a, b) => this.stopsRank(a) - this.stopsRank(b) || this.getFlightAmount(a) - this.getFlightAmount(b),
      duration_asc: (a, b) => this.getDurationMinutes(a) - this.getDurationMinutes(b),
      duration_desc: (a, b) => this.getDurationMinutes(b) - this.getDurationMinutes(a),
      dep_time_asc: (a, b) => this.compareDateStrings(this.getDepartureTime(a), this.getDepartureTime(b)),
      dep_time_desc: (a, b) => this.compareDateStrings(this.getDepartureTime(b), this.getDepartureTime(a)),
      arr_time_asc: (a, b) => this.compareDateStrings(this.getArrivalTime(a), this.getArrivalTime(b)),
      arr_time_desc: (a, b) => this.compareDateStrings(this.getArrivalTime(b), this.getArrivalTime(a))
    };

    const comparator = comparatorMap[sortOption] || comparatorMap[this.defaultSortOption];
    return [...flights].sort(comparator);
  }

  private compareDateStrings(dateA: string | null, dateB: string | null): number {
    const msA = dateA ? Date.parse(dateA) : Number.MAX_SAFE_INTEGER;
    const msB = dateB ? Date.parse(dateB) : Number.MAX_SAFE_INTEGER;
    return msA - msB;
  }

  /** Every matching flight is rendered; there is no paging. */
  get visibleFlights(): any[] {
    return this.availableFlights;
  }


  private applyFiltersAndSort(): void {
    console.log('[Filters] Applying filters', {
      selectedStops: [...this.selectedStops],
      selectedDepartureBuckets: [...this.selectedDepartureBuckets],
      selectedArrivalBuckets: [...this.selectedArrivalBuckets],
      selectedAirlines: [...this.selectedAirlines],
      checkedBagOnly: this.checkedBagOnly,
      sort: this.currentSortOption,
      totalFlights: this.allFlights.length
    });
    const stopsSet = new Set(this.selectedStops);
    const depSet = new Set(this.selectedDepartureBuckets);
    const arrSet = new Set(this.selectedArrivalBuckets);
    const airlineSet = new Set(this.selectedAirlines);

    const filtered = this.filterFlightsWith(stopsSet, depSet, arrSet, airlineSet, this.checkedBagOnly);

    this.filteredResultCount = filtered.length;
    this.availableFlights = this.sortFlights(filtered, this.currentSortOption);
    this.rebuildFacetCounts();
    this.rebuildQuickSortMetrics(filtered.length ? filtered : this.allFlights);
    this.updateTopAirlineTag();
    console.log('[Filters] Filtered result count', this.filteredResultCount);
  }

  private filterFlightsWith(
    stopsSet: Set<string>,
    departureSet: Set<string>,
    arrivalSet: Set<string>,
    airlineSet: Set<string>,
    requireCheckedBag: boolean
  ): any[] {
    return this.allFlights.filter((flight) => (
      this.passesStopsFilter(flight, stopsSet) &&
      this.passesDepartureBucketFilter(flight, departureSet) &&
      this.passesArrivalBucketFilter(flight, arrivalSet) &&
      this.passesAirlineFilter(flight, airlineSet) &&
      this.passesCheckedBagFilter(flight, requireCheckedBag)
    ));
  }

  private passesStopsFilter(flight: any, stops: Set<string>): boolean {
    if (stops.size === 0) {
      return true;
    }
    return stops.has(this.getStopsKey(flight));
  }

  private passesDepartureBucketFilter(flight: any, buckets: Set<string>): boolean {
    if (buckets.size === 0) {
      return true;
    }
    const departure = this.getDepartureTime(flight);
    if (!departure) {
      return false;
    }
    for (const bucket of buckets) {
      if (this.isTimeInBucket(departure, bucket)) {
        return true;
      }
    }
    return false;
  }

  private passesArrivalBucketFilter(flight: any, buckets: Set<string>): boolean {
    if (buckets.size === 0) {
      return true;
    }
    const arrival = this.getArrivalTime(flight);
    if (!arrival) {
      return false;
    }
    for (const bucket of buckets) {
      if (this.isTimeInBucket(arrival, bucket)) {
        return true;
      }
    }
    return false;
  }

  private passesAirlineFilter(flight: any, airlines: Set<string>): boolean {
    if (airlines.size === 0) {
      return true;
    }
    const code = this.getMarketingCarrierCode(flight);
    if (!code) {
      return false;
    }
    return airlines.has(code);
  }

  private passesCheckedBagFilter(flight: any, requireCheckedBag: boolean): boolean {
    if (!requireCheckedBag) {
      return true;
    }
    return this.hasCheckedBag(flight);
  }

  private isTimeInBucket(dateString: string, bucket: string): boolean {
    const hour = this.extractHourFromDateString(dateString);
    if (hour === null) {
      return false;
    }
    switch (bucket) {
      case 'before6':
        return hour < 6;
      case '6to12':
        return hour >= 6 && hour < 12;
      case '12to18':
        return hour >= 12 && hour < 18;
      case 'after18':
        return hour >= 18;
      default:
        return false;
    }
  }

  private extractHourFromDateString(value: string | null): number | null {
    if (!value) {
      return null;
    }

    const trimmed = value.trim();
    if (!trimmed) {
      return null;
    }

    const match = trimmed.match(/(?:t|\s)?(\d{1,2}):(\d{2})/i);
    if (match) {
      const hour = parseInt(match[1], 10);
      if (!isNaN(hour)) {
        return ((hour % 24) + 24) % 24;
      }
    }

    const normalized = trimmed.replace(' ', 'T');
    const parsed = new Date(normalized);
    if (!isNaN(parsed.getTime())) {
      return parsed.getHours();
    }

    return null;
  }

  private getMarketingCarrierCode(flight: any): string | null {
    const segment = this.getFirstSegment(flight);
    if (segment?.marketing_carrier?.iata_code) {
      return segment.marketing_carrier.iata_code;
    }
    const marketingCarrier = flight?.marketing_carrier || flight?.carrier;
    return marketingCarrier?.iata_code || null;
  }

  private rebuildAirlineFacets(): void {
    const counts = new Map<string, { name: string; count: number; logo?: string }>();
    this.allFlights.forEach((flight) => {
      const segment = this.getFirstSegment(flight);
      const code = segment?.marketing_carrier?.iata_code || '??';
      const name = segment?.marketing_carrier?.name || code;
      if (!counts.has(code)) {
        counts.set(code, { name, count: 0, logo: segment?.marketing_carrier?.logo });
      }
      const data = counts.get(code);
      if (data) {
        data.count += 1;
      }
    });

    this.airlineFacets = Array.from(counts.entries()).map(([code, data]) => ({
      code,
      name: data.name,
      count: data.count,
      logo: data.logo
    })).sort((a, b) => b.count - a.count || a.name.localeCompare(b.name));
  }

  private updateTopAirlineTag(): void {
    if (!this.airlineFacets.length) {
      this.topAirlineCode = null;
      this.topAirlineName = null;
      return;
    }
    const preferredFacet = this.airlineFacets[0];
    if (preferredFacet) {
      this.topAirlineCode = preferredFacet.code;
      this.topAirlineName = preferredFacet.name;
    } else {
      this.topAirlineCode = null;
      this.topAirlineName = null;
    }
  }

  toggleStopFilter(stop: string): void {
    this.toggleSelection(this.selectedStops, stop);
    console.log('[Filters] Toggle stop', { stop, selectedStops: [...this.selectedStops] });
    this.syncQuickPreset();
    this.applyFiltersAndSort();
  }

  toggleDepartureBucket(bucket: string): void {
    this.toggleSelection(this.selectedDepartureBuckets, bucket);
    console.log('[Filters] Toggle departure bucket', { bucket, selectedDepartureBuckets: [...this.selectedDepartureBuckets] });
    this.syncQuickPreset();
    this.applyFiltersAndSort();
  }

  toggleArrivalBucket(bucket: string): void {
    this.toggleSelection(this.selectedArrivalBuckets, bucket);
    console.log('[Filters] Toggle arrival bucket', { bucket, selectedArrivalBuckets: [...this.selectedArrivalBuckets] });
    this.syncQuickPreset();
    this.applyFiltersAndSort();
  }

  toggleAirline(code: string): void {
    this.toggleSelection(this.selectedAirlines, code);
    this.syncQuickPreset();
    this.applyFiltersAndSort();
  }

  toggleCheckedBag(): void {
    this.checkedBagOnly = !this.checkedBagOnly;
    this.syncQuickPreset();
    this.applyFiltersAndSort();
  }

  onSortChange(event: any): void {
    const value = event?.target ? event.target.value : event;
    this.currentSortOption = value;
    this.syncQuickPreset();
    this.applyFiltersAndSort();
  }

  applyQuickSortPreset(presetId: string): void {
    if (presetId !== 'cheapest' && presetId !== 'nonstop' && presetId !== 'prefer') {
      return;
    }
    const option = this.quickSortOptions.find(o => o.id === presetId);
    this.quickSortPreset = presetId;
    this.currentSortOption = option ? option.sort : this.defaultSortOption;
    this.applyFiltersAndSort();
  }

  clearAllFilters(): void {
    this.currentSortOption = this.defaultSortOption;
    this.quickSortPreset = 'cheapest';
    this.selectedStops = [];
    this.selectedDepartureBuckets = [];
    this.selectedArrivalBuckets = [];
    this.selectedAirlines = [];
    this.checkedBagOnly = false;
    this.applyFiltersAndSort();
  }

  // mobile specific handlers
  openMobileSortFilters(): void {
    this.isMobileSortFilterOpen = true;
    this.mobileSortFilterTab = 'sort';
    this.mobileSelectedSortOption = this.currentSortOption;
    this.mobileSelectedStops = [...this.selectedStops];
    this.mobileSelectedDepartureBuckets = [...this.selectedDepartureBuckets];
    this.mobileSelectedArrivalBuckets = [...this.selectedArrivalBuckets];
    this.mobileSelectedAirlines = [...this.selectedAirlines];
    this.mobileCheckedBagOnly = this.checkedBagOnly;
    this.hasPendingMobileChanges = false;
  }

  closeMobileSortFilters(): void {
    this.isMobileSortFilterOpen = false;
    this.hasPendingMobileChanges = false;
  }

  applyMobileSortFilters(): void {
    this.currentSortOption = this.mobileSelectedSortOption;
    this.selectedStops = [...this.mobileSelectedStops];
    this.selectedDepartureBuckets = [...this.mobileSelectedDepartureBuckets];
    this.selectedArrivalBuckets = [...this.mobileSelectedArrivalBuckets];
    this.selectedAirlines = [...this.mobileSelectedAirlines];
    this.checkedBagOnly = this.mobileCheckedBagOnly;
    this.syncQuickPreset();
    this.applyFiltersAndSort();
    this.hasPendingMobileChanges = false;
    this.closeMobileSortFilters();
  }

  toggleMobileSelection(listType: 'stops' | 'dep' | 'arr' | 'airline', value: string): void {
    if (listType === 'stops') {
      this.toggleSelection(this.mobileSelectedStops, value);
    } else if (listType === 'dep') {
      this.toggleSelection(this.mobileSelectedDepartureBuckets, value);
    } else if (listType === 'arr') {
      this.toggleSelection(this.mobileSelectedArrivalBuckets, value);
    } else if (listType === 'airline') {
      this.toggleSelection(this.mobileSelectedAirlines, value);
    }
    this.hasPendingMobileChanges = true;
  }

  toggleMobileCheckedBag(): void {
    this.mobileCheckedBagOnly = !this.mobileCheckedBagOnly;
    this.hasPendingMobileChanges = true;
  }

  onMobileSortOptionChange(value: string): void {
    this.mobileSelectedSortOption = value;
    this.hasPendingMobileChanges = true;
  }

  clearMobileSelections(): void {
    this.mobileSelectedSortOption = this.defaultSortOption;
    this.mobileSelectedStops = [];
    this.mobileSelectedDepartureBuckets = [];
    this.mobileSelectedArrivalBuckets = [];
    this.mobileSelectedAirlines = [];
    this.mobileCheckedBagOnly = false;
    this.hasPendingMobileChanges = true;
  }

  toggleNonStopQuickFilter(): void {
    if (this.selectedStops.length === 1 && this.selectedStops[0] === '0') {
      this.selectedStops = [];
    } else {
      this.selectedStops = ['0'];
    }
    if (this.currentSortOption !== 'price_asc') {
      this.currentSortOption = 'price_asc';
    }
    this.syncQuickPreset();
    this.applyFiltersAndSort();
  }

  toggleTopAirlineQuickFilter(): void {
    if (!this.topAirlineCode) {
      return;
    }

    if (this.selectedAirlines.length === 1 && this.selectedAirlines[0] === this.topAirlineCode) {
      this.selectedAirlines = [];
    } else {
      this.selectedAirlines = [this.topAirlineCode];
    }
    this.quickSortPreset = null;
    this.syncQuickPreset();
    this.applyFiltersAndSort();
  }

  toggleCheckedBagQuickFilter(): void {
    this.checkedBagOnly = !this.checkedBagOnly;
    this.syncQuickPreset();
    this.applyFiltersAndSort();
  }

  private toggleSelection(collection: string[], value: string): void {
    const index = collection.indexOf(value);
    if (index > -1) {
      collection.splice(index, 1);
    } else {
      collection.push(value);
    }
  }

  /** Quick sorts are plain sorts, so the highlighted preset follows the current sort option. */
  private syncQuickPreset(): void {
    const option = this.quickSortOptions.find(o => o.sort === this.currentSortOption);
    this.quickSortPreset = option ? option.id : null;
  }


  isObject(val) {
    return (typeof val === "object" && !Array.isArray(val) && val !== null);
  }

 acClick(){
   if(this.isAcClicked){
     this.isAcClicked=false;
   }else{
     this.isAcClicked=true;
   }

 }
isWaterClicked(){

  if(this.isWater){
    this.isWater=false;
  }else{
    this.isWater=true;
  }

}

logData(f){

}

checkIfArray(arr){

 return  Array.isArray(arr)
}

getJsonDepature(json){
    return JSON.parse(json).departure
}

getJsonReturn(json){

  return JSON.parse(json).return
}
claTimeDiff(t1:any,t2:any){
  var a = moment(t1, 'HH:mm');
    var b = moment(t2, 'HH:mm');
    let diff:any = a.diff(b, 'hours', true)
    return diff;
    //return 10
}

getPromoDiscountPercent(result: any): number {
  if (!result?.promo_discount || !result?.total_amount) return 0;
  return Math.round((result.promo_discount.user.amount / result.total_amount) * 100);
}

getPromoFinalAmount(result: any): number {
  if (!result?.promo_discount || !result?.total_amount) return 0;
  return result.total_amount - result.promo_discount.user.amount;
}

}
